module.exports = "/virtual-football-league/img/amblems/left/logos/Esp.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/Esp.png
// module id = 2067
// module chunks = 4